import { get } from 'lodash';
import i18next from 'i18next';

import { normalizeKeys } from '@commons/Excels/utils';
import normalizeStringValue from '@commons/utils/normalizeStringValue';

const getNonSalesConsumptionSheetConfig = () => {
  const columns = {
    NAME: i18next.t('_BACKEND_TRANSLATIONS.ENTITIES.INGREDIENTS_IMPORTS.INGREDIENT_NAME_COLUMN'),
    UNIT: i18next.t('_BACKEND_TRANSLATIONS.ENTITIES.INGREDIENTS_IMPORTS.UNIT_COLUMN'),
    INGREDIENT_ID: 'ingredientId',
  };

  const normalizedColumns = normalizeKeys(columns);

  return {
    SHEET: {
      id: 'nonSalesConsumptions',
      name: i18next.t(
        '_BACKEND_TRANSLATIONS.ENTITIES.INGREDIENTS_IMPORTS.NON_SALES_CONSUMPTION_SHEET_NAME',
      ),
    },
    COLUMN_IDS: {
      NAME: 'name',
      UNIT: 'unit',
      INGREDIENT_ID: 'ingredientId',
    },
    COLUMNS_CONFIG: normalizedColumns,
  };
};

const getNormalizedColumnIds = () => ({
  NAME: {
    key: 'name',
    normalizedKey: normalizeStringValue(
      i18next.t('_BACKEND_TRANSLATIONS.ENTITIES.INGREDIENTS_IMPORTS.INGREDIENT_NAME_COLUMN'),
    ),
  },
  INGREDIENT_ID: {
    key: 'ingredientId',
    normalizedKey: 'ingredientid',
  },
  UNIT: {
    key: 'unit',
    normalizedKey: normalizeStringValue(
      i18next.t('_BACKEND_TRANSLATIONS.ENTITIES.INGREDIENTS_IMPORTS.UNIT_COLUMN'),
    ),
    mappingFn: (row, normalizedKey) => {
      const value = get(row, normalizedKey, '');

      return value === i18next.t('GENERAL.UNIT') ? 'unit' : value;
    },
  },
});

export default {
  getNonSalesConsumptionSheetConfig,
  getNormalizedColumnIds,
};
